export const [
    EDITING_EMPLOYEE_ID,
    EDIT_EMPLOYEE_FILTER_TEXT,
] = [
    'EDITING_EMPLOYEE_ID',
    'EDIT_EMPLOYEE_FILTER_TEXT',
]
